import { createSlice } from '@reduxjs/toolkit';
import getTranslationsFromDomElements from '@/util/getTranslationsFromDomElements';

// Translations should be fetched via API request: RUUP-51
const translations = getTranslationsFromDomElements();

export type TranslationsState = Record<string, unknown>;

const initialState: TranslationsState = translations;

export const translationsSlice = createSlice({
  name: 'translations',
  initialState,
  reducers: {},
});

export default translationsSlice.reducer;
